<template lang="html">
    <div class="content">
        <!-- <p> Onze Werktafel wordt regelmatig aangepast. Bent u van plan te vi&shy;siteren? Maak altijd een af&shy;spraak met de Se&shy;cretaris van onze loge via on&shy;der&shy;staande knop. </p>
        <div>
            <a class="button" href="mailto:logelaforce@gmail.com?subject=Ik%20wil%20een%20keertje%20op%20bezoek%20komen">Aanmelden voor bezoek</a>
        </div> -->
        <!-- <hr />
        <p class="question">Belangrijke mededeling;</p>
        <p> Gezien de samenstelling van onze Loge en de doorlopende onzekerheden aangaande de uitbraak van het Corona virus blijft onze Loge tot nader order gesloten. <span style="text-decoration: underline;">Tenzij anders vermeld zijn de bijeenkomsten op onze Werktafel virtueel van aard.</span></p> -->
        <hr />
        <p>{{calTitle}}</p>
        <div class="wt-cal">
            <div v-for="(wtrow, wtrow_idx) in wtevents" v-bind:key="wtrow_idx" class="wt-row">
                <div v-for="(wte, wte_idx) in wtrow" v-bind:key="wte_idx">
                    <div id="upcoming" v-if="wte.upcoming">
                        <span>De eerst-volgende:</span>
                    </div>

                    <div class="wt-event" v-bind:class="{ upcoming: wte.upcoming, hasbeen: wte.hasbeen, isException: wte.isException }" v-bind:style="{ backgroundColor: wte.color1 }">
                        <div v-if="wte.tux" class="tux"></div>
                        <div v-if="wte.recycle" class="recycle"></div>
                        <span class="wte-date" v-bind:style="{ color: wte.color2 }" v-text="wte.date"></span>
                        <span class="wte-label" v-bind:style="{ color: wte.color2 }" v-text="wte.label"></span>
                    </div>
                </div>
            </div>
        </div>
        <hr />
        <p class="question">Let op;</p>
        <p> Onze Werktafel wordt regelmatig aangepast. Bent u van plan te vi&shy;siteren? Maak altijd een af&shy;spraak met de Se&shy;cretaris van onze loge via on&shy;der&shy;staande knop. </p>
        <div>
            <a class="button" href="mailto:logelaforce@gmail.com?subject=Ik%20wil%20een%20keertje%20op%20bezoek%20komen">Aanmelden voor bezoek</a>
        </div>
        <!-- <p class="quote">"De ziel van den mens groeit niet van loon, maar van den arbeid die het loon verdient." <span class="author">~ E.D. Dekker </span></p> -->
        <p class="quote">"There is no fun in doing nothing when you have nothing to do." <span class="author">~ J.K. Jerome </span></p>
        <Proceedings></Proceedings>
    </div>
</template>

<script>

import Proceedings from './Proceedings'

export default {
    components: {
        Proceedings
    },
    data: () => {
        return {
            wtevents: [],
            calTitle: 'Werktafel'
        }
    },
    methods: {
        loadEvents() {

            this.wtevents = 'loading'

            // --

            let wyb = new Date()
            let wye = new Date()
            const now_month = (new Date().getMonth() + 1)
            if(now_month <= 6) { // this should be a 6
                wyb.setYear(new Date().getFullYear()-1)
                wye.setYear(new Date().getFullYear())
            } else {
                wyb.setYear(new Date().getFullYear())
                wye.setYear(new Date().getFullYear()+1)
            }

            // console.log('wyb', wyb)

            // --

            wyb.setMonth(8)
            wyb.setDate(1)
            wyb.setHours(0)
            wyb.setMinutes(0)
            wyb.setSeconds(0)

            // --

            wye.setMonth(6)
            wye.setDate(1)
            wye.setHours(23)
            wye.setMinutes(59)
            wye.setSeconds(0)

            //

            // --

            var eligable = (date) => {
                const qdate = new Date(date)
                const e = qdate.getTime() > wyb.getTime() && qdate.getTime() < wye.getTime()
                return e
            }

            const isException = (date) => new Date(date).getDay() !== 1

            var monthize = (monthnum) => ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'][monthnum]

            /*
            {
                substr: '3e gr',
                color1: '#000',
                color2: '#673ab7',
                color3: '#b48bfb',
                tux: false,
                recycle: false
            }, 
            */

            var colorize = function(summary) {
                var reg = [{
                    substr: 'in forma',
                    color1: '#787878',
                    color2: '#bdbdbd',
                    color3: '#d8d8d8',
                    tux: true,
                    recycle: false
                }, {
                    substr: 'drive in',
                    color1: '#2196f3',
                    color2: '#22537b',
                    color3: '#22537b',
                    tux: false,
                    recycle: false
                }, {
                    substr: 'gesloten',
                    color1: '#1f1f1f',
                    color2: '#868686',
                    color3: '#c3c3c3',
                    tux: false,
                    recycle: false
                }, {
                    substr: 'inleiding',
                    color1: '#fdea01',
                    color2: '#4e4a27',
                    color3: '#000',
                    tux: false,
                    recycle: false
                }, {
                    substr: 'bezoek',
                    color1: '#725013',
                    color2: '#ffd180',
                    color3: '#000',
                    tux: false,
                    recycle: true
                }, {
                    substr: 'ladiesnight',
                    color1: '#148812',
                    color2: '#44d23f',
                    color3: '#7aec76',
                    tux: false,
                    recycle: false
                }, {
                    substr: 'oefenloge',
                    color1: '#364d75',
                    color2: '#7c9dd8',
                    color3: '#b3cfff',
                    tux: false,
                    recycle: false
                }, {
                    substr: 'leden-vergadering',
                    color1: '#ffc1e1',
                    color2: '#af5e88',
                    color3: '#67153e',
                    tux: false,
                    recycle: false
                }, {
                    substr: 'nieuwjaar',
                    color1: '#aed088',
                    color2: '#404e31',
                    color3: '#3a482a',
                    tux: false,
                    recycle: false
                }, {
                    substr: 'belangstellenden',
                    color1: '#fda300',
                    color2: '#4c340a',
                    color3: '#060400',
                    tux: false,
                    recycle: false
                }, {
                    substr: 'thema',
                    color1: '#7d50ca',
                    color2: '#c09bff',
                    color3: '#fff',
                    tux: false,
                    recycle: false
                }, {
                    substr: 'informele',
                    color1: '#333333',
                    color2: '#9c9c9c',
                    color3: '#828282',
                    tux: false,
                    recycle: false
                }, {
                    substr: 'voorbereiding',
                    color1: '#333333',
                    color2: '#585858',
                    color3: '#828282',
                    tux: false,
                    recycle: false
                }, {
                    substr: 'comp',
                    color1: '#333333',
                    color2: '#787878',
                    color3: '#828282',
                    tux: false,
                    recycle: false
                }]
                for(var i=0; i<reg.length; i++) {
                    if(summary.toLowerCase().indexOf(reg[i].substr) !== -1) {
                        return [reg[i].color1, reg[i].color2, reg[i].color3, reg[i].tux, reg[i].recycle]
                    }
                }
                return ['#1f1f1f', '#868686', '#c3c3c3']
            }

            /* ------------------------- */

            var nextItemDate = new Date().getTime() + 99999999999999
            const markUpcoming = () => {
                var nu = new Date().getTime()
                for(var i=0; i<events.length; i++) {
                    var e = events[i]
                    var cd = new Date(e.date_o).setHours(23, 59, 59, 999)
                    events[i].upcoming = false
                    events[i].upcoming = false
                    if(cd >= nu && cd < nextItemDate) {
                        nextItemDate = cd
                        events[i].upcoming = true
                    }
                    if(cd < nu) {
                        events[i].hasbeen = true
                    }
                }
            }

            /* ------------------------- */

            const ISODateString = (d) => {
                const pad = (n) => n<10 ? '0'+n : n
                return d.getUTCFullYear()+'-'
                    + pad(d.getUTCMonth()+1)+'-'
                    + pad(d.getUTCDate())+'T'
                    + pad(d.getUTCHours())+':'
                    + pad(d.getUTCMinutes())+':'
                    + pad(d.getUTCSeconds())+'Z'
            }

            /* ------------------------- */

            const visitorApplicable = (summary) => (summary.indexOf('O∴ L∴') !== -1) || (summary.indexOf('1e Gr∴ Comp∴ Bwstk∴') !== -1) || (summary.indexOf('2e Gr∴ Comp∴ Bwstk∴') !== -1) || (summary.indexOf('3e Gr∴ Comp∴ Bwstk∴') !== -1)

            /* ------------------------- */

            var xhttp = new XMLHttpRequest()
            var events = []
            // let title = 'Werktafel'

            // --

            const es = []

            // --

            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4 && xhttp.status == 200) {
                    var calendarEvents = JSON.parse(xhttp.responseText)
                    // console.log('calendarEvents', calendarEvents)
                    if(calendarEvents.hasOwnProperty('summary')) {
                        this.calTitle = calendarEvents.summary
                    }
                    if(calendarEvents.hasOwnProperty('items')) {
                        for(var i=0; i<calendarEvents.items.length; i++) {
                            var item = calendarEvents.items[i]
                            if(item.hasOwnProperty('start')) {
                                if(item.start.hasOwnProperty('date')) {
                                    var itemdate = new Date(item.start.date)
                                    // console.log(itemdate)
                                    if(eligable(itemdate)) {
                                        events.push({
                                            label: item.summary,
                                            date: [itemdate.getDate(), monthize(itemdate.getMonth()), itemdate.getFullYear()].join(' '),
                                            date_o: item.start.date,
                                            color1: colorize(item.summary)[0],
                                            color2: colorize(item.summary)[1],
                                            color3: colorize(item.summary)[2],
                                            rowIndicator: itemdate.getMonth(),
                                            tux: colorize(item.summary)[3],
                                            recycle: colorize(item.summary)[4],
                                            visitorApplicable: visitorApplicable(item.summary),
                                            isException: isException(item.start.date),
                                            id: item.id
                                        })
                                    }
                                }
                            }
                        }
                        markUpcoming()
                        let lri = 9999
                        let current = []
                        for(let i=0; i<Object.keys(events).length; i++) {
                            const e = events[i]
                            if(e.rowIndicator!==lri) {
                                lri = e.rowIndicator
                                if(current.length) {
                                    es.push(current)
                                }
                                current = []
                            }
                            current.push(e)
                        }
                        es.push(current)
                        this.wtevents = es;
                        console.log(es)
                        // next()
                    }
                }
            }
            xhttp.open('GET', 'https://www.googleapis.com/calendar/v3/calendars/md6pvqbg011gpb1v3veppo7kek@group.calendar.google.com/events?key=AIzaSyDMr67H6VSV5kUU0u9qKNNNSh4oL3_sJsc&orderBy=starttime&singleEvents=true&timeMin=' + ISODateString(wyb), true)
            xhttp.send()
        }
    },
    mounted() {
        this.loadEvents()
    },
    updated() {
        const upcoming = document.getElementById('upcoming')
        if(upcoming) {
            const newOffset = parseInt(upcoming.offsetTop) - 8
            document.body.scrollTop = document.documentElement.scrollTop = newOffset
        }
    }
}

</script>

<style lang="css" scoped>
    #upcoming {
        display: inline-block;
        float: left;
        box-sizing: border-box;
        padding: 20px 12px;
        display: none;
        background: black;
        width: 100%;
    }
    #upcoming span {
        color: white;
    }
    .image-werktafel {
        background: transparent url('/images/bouwplan.jpg') no-repeat center -80px;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    ul {
        /* margin: 0;
        padding: 0;
        list-style-type: none; */
    }
    li {
        color: white;
        font-size: 19px;
    }
    .wt-cal {
        /* position: absolute; */
        /* left: 0; */
        /* top: 0; */
        /* z-index: 30; */
        /* width: 100%; */
        /* background: #1f1f1f; */
        background: #101010;
        background: #000016;
        /* min-height: 6000px; */
    }
    .wt-row {
        border-bottom: solid 4px black;
    }
    .wt-event {
        display: inline-block;
        max-width: 190px;
        min-width: 190px;
        width: 190px;
        min-height: 120px;
        height: 120px;
        max-height: 120px;
        overflow: hidden;
        box-sizing: border-box;
        padding: 12px;
        border-right: solid 4px black;
        float: left;
        position: relative;
        transition: opacity .3s ease-out;
    }
    .upcoming {
        outline: solid 5px rgba(255, 255, 255, .3);
        border: solid 1px rgba(255, 255, 255, .6);
        z-index: 20;
    }
    .hasbeen {
        opacity: .5;
        cursor: default;
    }
    .hasbeen:hover {
        opacity: 1;
    }
    
    .wt-event span {
        font-size: 15px;
    }
    .wt-event:nth-child(5) {
        border-right: none;
    }
    .wt-row:after {
        content: '';
        display: block;
        height: 0px;
        background: red;
        width: 100%;
        clear: left;
    }
    .wte-date {
        display: block;
    }
    .wte-label {
        display: block;
    }
    .tux {
        width: 60px;
        height: 60px;
        background: transparent url('/images/tux.png') no-repeat center center;
        background-size: cover;
        position: absolute;
        bottom: -2px;
        right: -7px;
    }
    .recycle {
        width: 60px;
        height: 60px;
        background: transparent url('/images/recycle.png') no-repeat center center;
        background-size: cover;
        position: absolute;
        bottom: -2px;
        right: -7px;
    }
</style>
